const FT = {
    "1": "簡體中文",
    "2": "繁體中文",
    "3": "英文",
    "4": "登錄",
    "5": "ALL",
    "6": "新聞",
    "7": "比賽",
    "8": "活動",
    "9": "資訊",
    "10": "新店鋪",
    "11": "新聞列表",
    "12": "店鋪列表",
    "13": "店鋪活動",
    "14": "產品展示",
    "15": "社交媒體",
    "16": "近期成績",
    "17": "更改道具",
    "18": "退出",
    "19": "確定",
    "20": "我的頁面首頁",
    "21": "整體數據",
    "22": "遊戲資料",
    "23": "主店",
    "24": "好友聊天",
    "25": "其他設定",
    "26": "賬號",
    "27": "密碼",
    "28": "忘記賬號",
    "29": "忘記密碼",
    "30": "註冊新會員",
    "31": "國家/地區",
    "32": "語言",
    "33": "會員信息",
    "34": "ID",
    "35": "卡號",
    "36": "密碼",
    "37": "確認密碼",
    "38": "暱稱",
    "39": "電子郵件",
    "40": "請輸入6-20位英文字母或數字！",
    "41": "密碼必須由6-20個字母組成！",
    "42": "使用電子郵件驗證Adarts電子郵件地址！",
    "43": "必要的比賽信息",
    "44": "姓名",
    "45": "性別",
    "46": "SMS",
    "47": "出生日期",
    "48": "手機號碼",
    "49": "若要參加Adarts舉辦得各種比賽，以下資料為必填。",
    "50": "輸入以下資料和確認電子郵件以接受您可以在機器上立即使用的道具。",
    "51": "同意接受訊息",
    "52": "拒絕接受訊息",
    "53": "男",
    "54": "女",
    "55": "郵件設置",
    "56": "點擊【註冊】意味著您已同意Adarts的使用條款，並已閱讀且理解包括cookie使用在內的個人資料政策",
    "57": "註冊",
    "58": "忘記賬號ID",
    "59": "發送驗證碼",
    "60": "Adarts賬號密碼",
    "61": "Adarts賬號電子郵箱",
    "62": "Adarts賬號ID",
    "63": "請輸入正確的格式!",
    "64": "近30場成績",
    "65": "Award記錄",
    "66": "聊天內容",
    "67": "好友清單",
    "68": "新增好友",
    "69": "Adarts卡設定",
    "70": "賬號信息設定",
    "71": "Award消息設定",
    "72": "道具設定",
    "73": "密碼設定",
    "74": "Bull 數量",
    "75": "01總遊戲數量/勝率",
    "76": "Cricket總遊戲數量/勝率",
    "77": "總遊戲數量/勝率",
    "78": "Count Up平均分數",
    "79": "Count Up最高分數",
    "80": "最高分數",
    "81": "Bull 擊中率",
    "82": "S-Bull 擊中率",
    "83": "D-Bull 擊中率",
    "84": "Triple 擊中率",
    "85": "01 最快結標標數",
    "86": "請輸入用戶名！",
    "87": "請輸入密碼！",
    "88": "驗證碼",
    "89": "請輸入驗證碼！",
    "90": "請輸入郵箱！",
    "91": "請輸入賬號！",
    "92": "全部",
    "93": "好友",
    "94": "密友",
    "95": "操作",
    "96": "卡複製",
    "97": "刪除",
    "98": "添加卡",
    "99": "(國家/地區)/語言",
    "100": "卡登記日期",
    "101": "設定主題",
    "102": "圖像",
    "103": "如您已登記各種類型AWARD信息，比賽中在飛鏢機上刷 Adarts 線上卡時您的信息將在各AWARD時展示",
    "104": "AWARD信息",
    "105": "信息",
    "106": "AWARD",
    "107": "您可在此頁面更改密碼。此處更改的密碼將用於卡ID及賬號ID",
    "108": '舊密碼',
    "109": '新密碼',
    "110": '兩次密碼不一致！ ',
    "111": 'Adarts店鋪主頁',
    "112": 'Adarts搜索店鋪',
    "113": '已設置主題店鋪',
    "114": '最新店鋪',
    "115": '選擇區域',
    "116": '今日遊戲資料',
    "117": '推薦',
    "118": '玩家清單',
    "119": '排名',
    "120": '搜索店鋪',
    "121": '客服支援',
    "122": '7日內對戰選手',
    "123": '新增',
    "124": '接受',
    "125": '複製成功',
    "126": '確認刪除？ ',
    "127": '取消',
    "128": '本月',
    "129": '次數',
    "130": '請登錄之後查看我的頁面！ ',
    "131": '驗證方式',
    "132": '暫無數據',
    "133": '倒計時：',
    "134": '請輸入新密碼',
    "135": '我的頁面',
    "136": '道具商城',
    "137": 'Adarts店鋪',
    "138": '任務獎勵',
    "139": '選手介紹',
    "140": '飛鏢規格',
    "141": '大賽成績',
    "142": '選手影片',
    "143": '關聯商品',
    "144": '設置為主卡',
    "145": 'A1機器',
    "146": 'W1機器',
    "147": '查看地圖',
    "148": '主題Style',
    "149": '營業時間',
    "150": '休息日',
    "151": '地址',
    "152": '交通資訊',
    "153": '預算',
    "154": '主題',
    "155": '服務',
    "156": '網址',
    "157": '比賽排名',
    "158": '道具商店',
    "159": '飛鏢專欄',
    "160": '來自店鋪的資訊',
    "161": '主卡',
    "162": '主頁',
    "163": '我的ITEM',
    "164": 'ITEM購買',
    "165": 'ITEM商店索引',
    "166": '我的設定',
    "167": '我的ITEM LIST',
    "168": '兌換道具',
    "169": '推薦ITEM',
    "170": '新ITEM',
    "171": '排名ITEM',
    "172": '道具兌換為金幣',
    "173": '選擇範本',
    "174": '保存設定',
    "175": 'Style設定',
    "176": '使用中的Item',
    "177": 'Award 設定',
    "178": '續期',
    "179": '所選道具',
    "180": '道具的使用期延長後，您將無法取消！',
    "181": '兌換金幣數量',
    "182": '當前金幣數量',
    "183": '合計金幣數量',
    "184": '道具詳細資訊',
    "185": '擁有的金幣',
    "186": '贈送禮品',
    "187": '請求禮物',
    "188": '是否購買',
    "189": '購買並應用',
    "190": '購買',
    "191": '什麼是GOLD？',
    "192": 'GOLD的獲取方法',
    "193": '什麼是Item Shop？',
    "194": 'Gold Item 分類 & Item 種類',
    "195": '購買Item & Custom(Item設定與取消)',
    "196": '最近對戰對手',
    "197": '選擇',
    "198": '最後遊玩時間(天)',
    "199": '已發送好友請求',
    "200": 'AWARD排名',
    "201": '進行中',
    "202": '已結束',
    "203": '舉辦店鋪',
    "204": '活動日期',
    "205": '飛鏢機',
    "206": '參加方法',
    "207": '聯繫方式',
    "208": '比賽時間',
    "209": '請求禮物',
    "210": '活動描述',
    "211": '參賽方法',
    "212": '參賽費用',
    "213": '報名費',
    "214": '獎勵',
    "215": '其它',
    "216": '未開始',
    "217": '禮物盒',
    "218": '已收到得禮物',
    "219": '已收到得禮物請求',
    "220": '贈送好友',
    "221": '贈送時間',
    "222": '全部接受',
    "223": '依購買時間排序排列',
    "224": '依購買時間倒序排列',
    "225": '※ Item 下面的日期為購買日期',
    "226": '扣除的金幣',
    "227": '最多儲存10個道具套裝',
    "228": '若您想要保存另外的道具套裝時，請在道具套裝選擇中，刪除不必要的套裝',
    "229": '請輸入ITEM套裝名稱',
    "230": '不使用道具套裝',
    "231": '同意',
    "232": '拒絕',
    "233": '請求時間',
    "234": '店鋪類型',
    "235": '最高連勝',
    "236": '日語',
    "237": '請輸入新卡號',
    "238": '請使用全新卡進行卡複製功能，複製後，原卡將無法使用',
    "239": '發送',
    "240": '忘記帳號或密碼',
};
export default FT;